/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect} from 'react';
import {connectHierarchicalMenu} from 'react-instantsearch-dom';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles({
  item: ({level}) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    cursor: 'pointer',
    paddingLeft: level * 10,
  }),
  itemLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: '#ececec',
      padding: 5,
    },
  },
});

function RenderTree({node, path, level, refine}) {
  const classes = useStyles({level});

  return (
    <div className={classes.item}>
      <div className={classes.itemLabel} onClick={() => refine(path)}>
        <Typography
          variant={'body1'}
          style={{
            fontSize: level === 0 ? 14 : 12,
            fontWeight: node.isRefined ? 'bold' : '',
          }}
        >
          {node.label}
        </Typography>
        <Typography variant={'body1'}>{node.count}</Typography>
      </div>
      {Array.isArray(node.items)
        ? node.items.map((n) => (
            <RenderTree
              key={`${path} > ${n.label}`}
              node={n}
              path={`${path} > ${n.label}`}
              level={level + 1}
              refine={refine}
            />
          ))
        : null}
    </div>
  );
}

function AlgoliaCategories({items, refine}) {
  const querystring = window.location.search;

  useEffect(() => {
    const params = new URLSearchParams(querystring);
    refine(params.get('hierarchicalMenu[categories.lvl0]'));
  }, [querystring]);

  if (!items.length) {
    return <div>{/* No hay categorias */}</div>;
  }

  return (
    <Box style={{width: "100%"}} mb={2}>
      <Box mb={1} clone>
        <Divider />
      </Box>
      <Typography variant={'h5'}>Categorías</Typography>
      <Box my={1}>
        <Divider />
      </Box>
      {items.map((n) => (
        <RenderTree
          key={n.label}
          node={n}
          path={n.label}
          level={0}
          refine={refine}
        />
      ))}
    </Box>
  );
}

export default connectHierarchicalMenu(AlgoliaCategories);